import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";
import { isValidMobileNumber } from "../utils/validation";

const InputText = forwardRef((props, ref) => {
  const handleNumberInputChange = (e) => {
    const { value } = e.target;
    if (props.inputType === "number" && props.maxLength && value.length > props.maxLength) {
      e.target.value = value.slice(0, props.maxLength);
    }

    if (!isValidMobileNumber(value)) {
      console.log("Invalid mobile number. It must be 10 or 11 digits.");
    } else {
      console.log("");
    }

    if (typeof props.controlFunc === 'function') {
      props.controlFunc(e);
    }
  };

  // const handleDateChange = (e) => {
  //   const { value } = e.target;

  //   if (props.inputType === "date") {
  //     const inputDate = new Date(value);
  //     const today = new Date();

  //     // Reset hours to start of day for accurate comparison
  //     today.setHours(0, 0, 0, 0);
  //     inputDate.setHours(0, 0, 0, 0);

  //     // Handle max date validation (prevent future dates)
  //     if (props.max && inputDate > today) {
  //       // If input date is in the future, reset to today's date
  //       e.target.value = today.toISOString().split('T')[0];
  //       if (typeof props.controlFunc === 'function') {
  //         props.controlFunc({
  //           ...e,
  //           target: {
  //             ...e.target,
  //             value: today.toISOString().split('T')[0]
  //           }
  //         });
  //       }
  //       return;
  //     }
  //     // Handle min date validation (prevent past dates)
  //     if (props.min && inputDate < today) {
  //       // If input date is in the past, reset to today's date
  //       e.target.value = today.toISOString().split('T')[0];
  //       if (typeof props.controlFunc === 'function') {
  //         props.controlFunc({
  //           ...e,
  //           target: {
  //             ...e.target,
  //             value: today.toISOString().split('T')[0]
  //           }
  //         });
  //       }
  //       return;
  //     }

  //     // If date is current or past, allow it
  //     if (typeof props.controlFunc === 'function') {
  //       props.controlFunc(e);
  //     }
  //   }
  // };

  const handleDateChange = (e) => {
  const { value } = e.target;

  if (props.inputType !== "date") {
    if (typeof props.controlFunc === "function") {
      props.controlFunc(e);
    }
    return;
  }

  // HTML date input always returns YYYY-MM-DD.
  // Compare the strings directly to avoid timezone problems.
  if (props.max && value > props.max) {
    e.target.value = props.max;

    if (typeof props.controlFunc === "function") {
      props.controlFunc({
        ...e,
        target: {
          ...e.target,
          value: props.max,
        },
      });
    }
    return;
  }

  if (props.min && value < props.min) {
    e.target.value = props.min;

    if (typeof props.controlFunc === "function") {
      props.controlFunc({
        ...e,
        target: {
          ...e.target,
          value: props.min,
        },
      });
    }
    return;
  }

  // Valid date
  if (typeof props.controlFunc === "function") {
    props.controlFunc(e);
  }
};
  return (
    <div className={props.classDiv ? props.classDiv : "form-group"}>
      <label className={props.classLabel ? props.classLabel : mainTable.label}>
        {props.title}
        <span className={props.classStar ? props.classStar : "hidden"}>*</span>
      </label>

      {props.inputType === "file" ? (
        <div>
          <input
            ref={ref}
            className={props.Class ? props.Class : mainTable.input}
            name={props.name}
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={props.handleImageUpload}
            onBlur={props.handleImageUploadBlur}
            disabled={props.disabled}
            tabIndex={props.tabIndex}
          />

          {/* Show image limit message */}
          {props.limitMassage && (
            <small
              style={{
                display: "block",
                marginTop: "5px",
                color: "#6b7280",
                fontSize: "13px",
              }}
            >
              {props.limitMassage}
            </small>
          )}

          {/* Show error message */}
          {props.errorMessage && (
            <span className="text-red-500 text-sm font-medium">
              {props.errorMessage}
            </span>
          )}
        </div>
      ) : props.inputType === "image" ? (
        <img src={props.src} alt={props.alt} className={props.className} />
      ) : (
        <div className="relative">
          <input
            ref={ref}
            // className={props.Class ? props.Class : mainTable.input}
            //           className={
            //   props.Class
            //     ? props.Class
            //     : props.inputType === "date" || props.inputType === "datetime-local" || props.inputType === "time"
            //     ? mainTable.inputDate
            //     : mainTable.input
            // }
            className={
              props.Class
                ? props.Class
                : props.inputType === "date" ||
                  props.inputType === "datetime-local" ||
                  props.inputType === "time"
                  ? mainTable.inputDate + " pr-10" // only add padding for date/time
                  : mainTable.input
            }
            name={props.name}
            type={props.inputType}
            value={props.content}
            onChange={
              props.inputType === "number"
                ? handleNumberInputChange
                : props.inputType === "date"
                  ? handleDateChange
                  : props.controlFunc
            }
            errorMessage={props.errorMessage}
            onBlur={props.controlFuncBlur}
            onClick={props.handleImageUpload}
            placeholder={props.placeholder}
            disabled={props.disabled}
            tabIndex={props.tabIndex}
            maxLength={props.maxLength}
            min={props.min}
            max={props.max}
          />
          {/* custom icon */}
          {(props.inputType === "date" || props.inputType === "datetime-local") && (
            <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-500">
              📅
            </span>
          )}
          {props.inputType === "time" && (
            <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-500">
              ⏰
            </span>
          )}
          {props.errorMessage && (
            <span className="text-red-500 text-sm font-medium">
              {props.errorMessage}
            </span>
          )}
        </div>
      )}
    </div>
  );
});

InputText.propTypes = {
  inputType: PropTypes.oneOf([
    "text",
    "number",
    "password",
    "email",
    "file",
    "time",
    "date",
    "datetime-local",
  ]),
  title: PropTypes.string,
  name: PropTypes.string,
  limitMassage: PropTypes.string,
  controlFunc: PropTypes.func,
  controlFuncBlur: PropTypes.func,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.oneOf([null])  // allow null too
  ]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  handleImageUpload: PropTypes.func,
  handleImageUploadBlur: PropTypes.func,
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  maxLength: PropTypes.number,
  min: PropTypes.string,
  max: PropTypes.string,
};

export default InputText;